module.exports = __webpack_public_path__ + "media/images/hodzzy-desc-2-11258ca61ad95a92d6d9c0bf1e2f995b.png";